module.exports = "/src/views/player/documets/army/images/Armylogo.png";